import React from 'react';
import { injectIntl } from 'react-intl';
import { autotranslateText, isNotEmpty } from '../../lib/ep';

const TypeButton = ({ children, ...props }) => {
	const _props = {...props};
	if(_props['aria-label'] != undefined && _props._href == undefined && _props.onClick == undefined) _props['aria-label'] = null;

	return (
		<button {..._props}>
			{children}
		</button>
	)
};

const TypeLink = ({ children, ...props }) => {
	const _props = {...props};
	if(_props['aria-label'] != undefined && _props._href == undefined && _props.onClick == undefined) _props['aria-label'] = null;

	return (
		<a {..._props}>
			{children}
		</a>
	)
};

const TypeSpan = ({ children, ...props }) => {
	return (
		<span {...props}>
			{children}
		</span>
	)
};

const hasButtonClass = (icon) => {
	if(!icon) return false;
	if(icon == undefined) return false;

	const cls = icon.split(" ");

	for(var cl in cls) {
		if(/Button$/.test(cls[cl])) return true;
	}
	return false;
}

export const CreateButton = injectIntl((props) => {
	return (
		<MainButton
			icon='knk-add-item'
			{...props}
		/>
	)
});

export const MainButton = injectIntl((props) => {
	return (
		<ActionButton
			color={props?.color ?? 'main'}
			main={true}
			{...props}
		/>
	)
});

export const SecondaryButton = injectIntl((props) => {
	return (
		<ActionButton
			secondary={true}
			{...props}
		/>
	)
});

export const SquaredButton = injectIntl((props) => {
	return (
		<ActionButton
			squared={true}
			{...props}
			children={null}
		/>
	)
});

export const BackButton = injectIntl(({ children, ...props }) => {
	return (
		<ActionButton
			icon='knk-go-prev'
			secondary={true}
			{...props}
		>{(children != undefined) ? children : "Go back"}</ActionButton>
	)
});

const ActionButton = (props) => {
	const fullclass = props?._fullclass ?? false;
	const disabled = props?.disabled ?? false;
	const href = (props._href != undefined && !disabled) ? props._href : null;
	let squared = props?.squared ?? false;
	const main = props?.main ?? false;
	const secondary = props?.secondary ?? false;
	let icon = props?.icon ?? false;
	const color = props?.color ?? 'blue';
	const svg_icon = props?.svg_icon ?? '';
	const extra_after = props?.extra_after ?? '';
	const label = autotranslateText(props.children, props.autotranslate, props.intl);
	let _class = props?._class ?? {};

	if(label == null) {
		// if the label is missing, convert the button in squared format with blank icon:
		squared = true;
		if(_class.icon == undefined && icon === false) {
			icon = 'knk-white-space';
			if(color !== false) icon += ` ${color}Button`;
		}
	}

	const onClick = (e, cb) => {
		if(disabled) return;

		if(props._href == undefined) e.preventDefault();
		if(props.stopPropagation) e.stopPropagation();

		if(props.onClick != undefined) props.onClick(e);
		if(cb != undefined) cb();
	};

	let classes_div = ['gui_pos_rel'];

	let classname;
	let classes;
	if(fullclass === false) {
		let isSubmit = true;
		let inTop = true;

		classname = props?.classname ?? '';
		classes = classname.split(" ");
		
		if(_class) {
			for(let i in _class) {
				if(i == 'icon_off') continue;

				switch(i) {
					case 'fake':
						if(_class[i]) classes.push('gui_fake_button');
						break;

					case 'in_top':
					case 'first':
						inTop = _class[i];
						break;

					case 'submit':
						isSubmit = _class[i];
						break;

					case 'circled':
						break;

					case 'other':
						classes_div.push(_class[i]);
						break;

					default:
						classes.push(_class[i]);
						break;
				}
			}
		}
		if(isSubmit) classes.push('gui_flex_submit');
		if(inTop) classes_div.push('in_top');

		if(main) classes.push('gui_main_button');
		if(secondary) classes.push('gui_secondary_button');
	
		if(squared) {
			classes.push('alone_submit gui_square_button');
	
			if(color != false && (_class['variable_icon_color'] == undefined || _class['variable_icon_color'] == false) && color != 'transparent') {
				classes.push(`${color}Icon`);
			}
	
			if(color != false && !hasButtonClass(_class?.icon) && !hasButtonClass(icon)) classes.push('transparentButton');
	
			if(_class['circled'] != undefined && _class['circled']) classes.push('circledButton');
		} else if(color !== false) {
			classes.push(`${color}Button`);
		}
	} else {
		classname = fullclass;
		classes = classname.split(" ");
	}

	if(icon) classes.push(icon);

	if(disabled) classes.push('gui_disabled_button');

	classname = classes.filter((i) => (i != "" && i != " ")).join(" ");
	const classname_div = classes_div.filter((i) => (i != "" && i != " ")).join(" ");

	let datas = {};
	if(props.data_attr != undefined) {
		for(let i in props.data_attr) {
			datas[i] = props.data_attr[i];
		}
	}

	const item_props = {
		href,
		id:(props?._id ?? null),
		...datas,
		rel:(props?._nofollow ?? null),
		style:props.style,
		onClick,
		download:(props?.download ?? false),
	};

	if(href != undefined) {
		item_props.target = props?._target ?? '_self';
	}
	
	const secondary_props = {
		onMouseEnter:(props?.onMouseEnter ?? null),
		onMouseLeave:(props?.onMouseLeave ?? null),
		onMouseDown:(props?.onMouseDown ?? null),
		onMouseUp:(props?.onMouseUp ?? null),
		onTouchStart:(props?.onTouchStart ?? null),
		onTouchEnd:(props?.onTouchEnd ?? null),
		onContextMenu:(props?.onContextMenu ?? null),
	};

	// at the moment, only paint <a /> (no <button />) because buttons have custom backgrounds and this affect the front-end flexButtons
	// (where) the background color is in its container
	let Component = ((isNotEmpty(props, '_href')) || true) ? TypeLink : TypeButton;
	if(props?.is_span ?? false) Component = TypeSpan;

	if(props.tooltip != undefined && !squared && props.children != undefined) {
		return (
			<div class={classname_div} {...secondary_props}>
				<Component class={classname} {...item_props}>
					{svg_icon}
					{label}
					{extra_after}
				
					{props.tooltip}
				</Component>
			</div>
		)
	}

	return (
		<Component
			class={`alone_button ${classname} ${classname_div}`}
			{...item_props}
			{...secondary_props}
		>
			{svg_icon}
			{label}
			{extra_after}

			{(props.tooltip != undefined) && (
				props.tooltip
			)}
		</Component>
	);
}

export default injectIntl(ActionButton);